export const colours = {
	gray: {
		50: "#f7f7f7",
		100: "#f0f0f0",
		200: "#e0e0e0",
		300: "#d1d1d1",
		400: "#b3b3b3",
		500: "#969696",
		600: "#737373",
		700: "#525252",
		800: "#333333",
		900: "#262626",
	},
	neutrals: {
		50: "#f4f5f7",
		300: "#5e6c84",
	},
	blue: {
		500: "#0075DB0D",
		600: "#003A6D",
	},
	red: {
		500: "#AD1F1F",
	},
	blueGray: {
		300: "#8c94a1",
		400: "#6B778C",
		600: "#54698c",
	},
	navy: {
		700: "#505f79",
		800: "#42526E",
	},
	text: {
		body: "#051839",
	},
	danger: {
		icon: "#CB4655",
		background: {
			strong: "#CB4655",
			medium: "#FFDADB",
			weaker: "#FFEFEF",
		},
	},
	highlight: {
		"new-row-bg": "#DDFBF760",
	},
};
